import { KYMW0902Component } from './kymw0902.component';
import { DutiesDivPlanGoodsSearchConditionModel } from './vo/duties-div-plan-goods-search-condition.model';
import { KYMW0300InputModel } from '../../kymw03/kymw0300/vo/kymw0300-input.model';
import { DutiesDivPlanGoodsModel } from './vo/duties-div-plan-goods.model';

/**
 * 業態別企画設定画面の値を管理するクラス
 *
 * @export KYMW0902Model
 * @class KYMW0902Model
 */
export class KYMW0902Model {

  kymw0902Component: KYMW0902Component;

  // 業態別企画商品一覧データ
  public planGoodsList: Array<any> = [];

  // 業態別企画商品一覧の総件数
  public totalNum = Number(0);

  // 業態別企画商品一覧の開始件数
  public startDispNum = Number(0);

  // 業態別企画商品一覧の終了件数
  public endDispNum = Number(0);

  // 業態別企画商品一覧の現在ページ
  public pageNum = Number(1);

  // 業態別企画商品一覧の次へボタン活性状況
  public activeBtnNext = false;

  // 業態別企画商品一覧の前へボタン活性状況
  public activeBtnBack = false;

  // ソートキー
  public sortKey = String('');

  // ソート順
  public orderKey = String('');

  // 編集有無フラグ
  public isEdited = false;

  // 画面表示用
  public orderCode = String('');
  public dutiesFormDailyDiv = String('00');

  /**
   * 業態別企画商品リストの取得
   *
   * @param {*} data
   * @memberof KYMW0902Model
   */
  public setDutiesDivPlanGoodsList(data: any): void {
    if (data === null) {
      this.planGoodsList = [];
      this.totalNum = 0;
      this.startDispNum = 0;
      this.endDispNum = 0;
    } else {
      this.planGoodsList = data.DutiesDivPlanGoodsList;
      this.totalNum = Number(data.TotalNum);
      this.startDispNum = Number(data.StartDispNum);
      this.endDispNum = Number(data.EndDispNum);
    }

    // 変更フラグ、選択チェックの初期化
    for (let i = Number(0); i < this.planGoodsList.length; i++) {
      this.planGoodsList[i]['Selected'] = Boolean(false);
      this.planGoodsList[i]['ChangeFlag'] = Boolean(false);
    }

    // １ページの表示可能件数を超えている場合、次へボタンを有効化
    this.activeBtnNext = this.totalNum > this.endDispNum;
    // 前へボタンの有効化制御
    this.activeBtnBack = this.startDispNum > 1;

    // 業態別企画商品一覧の有効化
    this.kymw0902Component.dtg_PlanGoodsList.isDisabled = false;
    // 全選択、全解除の有効化
    this.kymw0902Component.plessEnabled(this.kymw0902Component.btn_AllSelect, true);
    this.kymw0902Component.plessEnabled(this.kymw0902Component.btn_AllUnSelect, true);
    // 取消の有効化
    this.kymw0902Component.plessEnabled(this.kymw0902Component.btn_Cancel, true);
    // 更新の有効化
    this.kymw0902Component.plessEnabled(this.kymw0902Component.btn_Update, true);
    // デイリー指定の有効化
    this.kymw0902Component.plessEnabled(this.kymw0902Component.btn_Reflection, true);
    // 編集フラグの初期化
    this.isEdited = false;
  }

  /**
   * 業態別企画商品検索条件保持用VO取得
   *
   * @param {KYMW0300InputModel} inputVo
   * @returns {DutiesDivPlanGoodsSearchConditionModel}
   * @memberof KYMW0902Model
   */
  public getDutiesDivPlanGoodsSearchConditionVO(inputVo: KYMW0300InputModel): DutiesDivPlanGoodsSearchConditionModel {
    const vo: DutiesDivPlanGoodsSearchConditionModel = new DutiesDivPlanGoodsSearchConditionModel();

    // 業態別企画商品検索条件保持用VOの初期化処理
    vo.orderCode = this.orderCode;
    vo.pcode = inputVo.pcode;
    vo.itemCode = inputVo.itemCode;
    vo.ebaseSpecCode = inputVo.ebaseSpecCode;
    vo.dataType = inputVo.dataType;
    vo.janCode = inputVo.janCode;
    vo.makerName = inputVo.makerName;
    vo.ordrClientCode = inputVo.ordrClientCode;
    vo.ordrClientKanji = inputVo.ordrClientKanji;
    vo.payeeClientCode = inputVo.payeeClientCode;
    vo.payeeClientKanji = inputVo.payeeClientKanji;
    vo.classCode = inputVo.classCode;
    vo.middleClassCode = inputVo.middleClassCode;
    vo.smallClassCode = inputVo.smallClassCode;
    vo.registDateFrom = inputVo.registDateFrom;
    vo.registDateTo = inputVo.registDateTo;
    vo.updateDateFrom = inputVo.updateDateFrom;
    vo.updateDateTo = inputVo.updateDateTo;
    vo.admitStatus = inputVo.admitStatus;
    vo.buyerCode = inputVo.buyerCode;
    vo.guideGoodsNameList = inputVo.guideGoodsNameList;
    vo.guideStandardNameList = inputVo.guideStandardNameList;
    vo.goodsDiv = inputVo.goodsDiv;
    vo.dataKbnFlg = inputVo.dataKbnFlg;
    vo.tagSearchType = inputVo.tagSearchType;
    vo.goodsMarkSearchType = inputVo.goodsMarkSearchType;

    // 業態区分
    vo.dutiesFormWeeklyDiv = (inputVo.dutiesFormWeekly) ? '1' : '';
    vo.dutiesFormDailyDivList = inputVo.duties;
    vo.dutiesFormSpotDiv = (inputVo.dutiesFormSpot) ? '1' : '';

    vo.tagIdList = inputVo.tagId;
    vo.goodsMarkList = inputVo.goodsMark;
    vo.coopCodeList = inputVo.coopCodeList;
    vo.pcodeList = inputVo.pcodeList;
    vo.itemCodeList = inputVo.itemCodeList;
    vo.pageNo = this.pageNum;
    vo.sortKey = this.sortKey;
    vo.orderKey = this.orderKey;

    // 商品企画検索用VOを返却
    return vo;
  }

  /**
   * 選択チェック全選択、全解除処理を行う
   *
   * @param {boolean} flg true：選択あり、false：選択なし
   * @memberof KYMW0902Model
   */
  public updatePageListAllSelected(flg: boolean): void {
    for (let i = Number(0); i < this.planGoodsList.length; i++) {
      this.planGoodsList[i]['Selected'] = flg;
    }
  }

  /**
   * データグリッド「業態別企画商品一覧」から、業態区分が変更されている業態別企画商品VOの一覧を取得する。
   *
   * @return 業態別企画商品VOの一覧
   */
  public getChangedDutiesDivFormDailyVOList(): Array<any> {
    const DutiesDivPlanGoodsListVO: Array<any> = [];

    if (this.planGoodsList != null) {
      for (let i = Number(0); i < this.planGoodsList.length; i++) {
        const changeFlag: boolean = this.planGoodsList[i]['ChangeFlag'];

        if (changeFlag) {
          const vo: DutiesDivPlanGoodsModel = new DutiesDivPlanGoodsModel;
          // Ｐコード
          vo.Pcode = this.planGoodsList[i]['Pcode'];
          // 業態区分（デイリー）
          vo.DutiesFormDailyDiv = this.planGoodsList[i]['DutiesFormDailyDiv'];
          // 更新日時
          vo.UpdateDate = this.planGoodsList[i]['UpdateDate'];

          DutiesDivPlanGoodsListVO.push(vo);
        }
      }
    }
    return DutiesDivPlanGoodsListVO;
  }

  /**
   * データグリッド「業態別企画商品一覧」の指定行の「デイリー」を更新する
   *
   * @param index ステータスを更新する行
   */
  public setStatusOrderNumList(index: number): void {
    this.isEdited = true;
    // デイリーの：が全角であれば指定のデイリーも全角にする
    this.planGoodsList[index]['DutiesFormDailyDivName'] = this.planGoodsList[index]['DutiesFormDailyDivName'].includes(':') ? this.kymw0902Component.cmb_DutiesFormDailyDiv.selectedCodeValueName.replace('：', ':') : this.kymw0902Component.cmb_DutiesFormDailyDiv.selectedCodeValueName.replace(':', '：')
    this.planGoodsList[index]['DutiesFormDailyDiv'] = this.kymw0902Component.cmb_DutiesFormDailyDiv.selectedCodeValue;
    this.planGoodsList[index]['ChangeFlag'] = Boolean(true);
  }
}
